import {getPrivateAxios} from '../../libs';

export const fetchCollectionPdf = async (id: string) => {
  return getPrivateAxios()
    .get(`collections/${id}/print`, {responseType: 'blob'})
    .then((response) => {
      return response.data;
    });
};
